import React from 'react';

import { Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';

export const CountryShow: React.FC<ShowProps> = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="shortCode" />
      <TextField source="regions" />
    </SimpleShowLayout>
  </Show>
);
